// Languages supported for per-product translations.
// English (`en`) is the canonical fallback and must always be filled in.
//
// Adding a language here requires:
//   - Updating `availableLanguages` in piffl-server (src/common/languages.ts) and adding the field to
//     ProductTranslations / ProductTranslationsInput in the GraphQL schema (src/features/product/type-defs.ts).
//   - Re-running GraphQL codegen here so the GQL_ProductTranslationsInput type gains the field.

export const SUPPORTED_PRODUCT_TRANSLATION_LANGUAGES = ['en', 'sv', 'no', 'da'] as const

export type SupportedProductTranslationLanguage = (typeof SUPPORTED_PRODUCT_TRANSLATION_LANGUAGES)[number]

export const PRODUCT_TRANSLATION_LANGUAGE_LABELS: Record<SupportedProductTranslationLanguage, string> = {
  en: 'English',
  sv: 'Swedish',
  no: 'Norwegian',
  da: 'Danish',
}

export const CANONICAL_FALLBACK_LANGUAGE: SupportedProductTranslationLanguage = 'en'

// The non-canonical languages are the ones the form's Translations section asks for explicitly.
// English (the canonical fallback) is captured via the top-level Name/Description fields and copied
// into translations.en automatically on save, so it isn't part of this list.
export type NonCanonicalProductTranslationLanguage = Exclude<SupportedProductTranslationLanguage, 'en'>

export const NON_CANONICAL_PRODUCT_TRANSLATION_LANGUAGES: ReadonlyArray<NonCanonicalProductTranslationLanguage> =
  SUPPORTED_PRODUCT_TRANSLATION_LANGUAGES.filter((lang): lang is NonCanonicalProductTranslationLanguage => lang !== CANONICAL_FALLBACK_LANGUAGE)
